import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CapAlertType} from "./cap-alert.enum";

@Component({
  selector: "cap-bsg-alert",
  template: `
    <div
      class="alert fade alert-{{ type.toString().toLowerCase() }}"
      [class.alert-dismissible]="dismissible"
      [class.show]="!fading"
      role="alert"
    >
      <button
        type="button"
        class="close"
        [attr.aria-label]="'Close' | translate"
        (click)="fading = true; dismiss.emit()"
        *ngIf="dismissible"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <span class="fas {{ icons[type] }} mr-2"></span>
      <ng-content></ng-content>
    </div>
  `
})
export class CapAlertComponent {
  @Input()
  type: CapAlertType;

  @Output()
  dismiss = new EventEmitter<void>();

  get dismissible() {
    return this.dismiss.observers.length;
  }

  fading = false;

  icons = {
    [CapAlertType.DANGER]: "fa-exclamation-circle",
    [CapAlertType.WARNING]: "fa-exclamation-triangle",
    [CapAlertType.INFO]: "fa-info-circle",
    [CapAlertType.SUCCESS]: "fa-check-circle"
  };
}
